import { combineReducers } from "redux";
import { createReducer, createResourceReducer } from "./create";
import * as T from "../actions/employees";

const putEmployee = createResourceReducer(
  T.PUT_EMPLOYEE_LOADING,
  T.PUT_EMPLOYEE_SUCCESS,
  T.PUT_EMPLOYEE_FAILURE,
  T.PUT_EMPLOYEE_CLEAR,
);
const putEmployeeCrmPermissions = createResourceReducer(
  T.PUT_EMPLOYEE_CRM_PERMISSIONS_LOADING,
  T.PUT_EMPLOYEE_CRM_PERMISSIONS_SUCCESS,
  T.PUT_EMPLOYEE_CRM_PERMISSIONS_FAILURE,
  T.PUT_EMPLOYEE_CRM_PERMISSIONS_CLEAR,
);
const postEmployee = createReducer(
  T.POST_EMPLOYEE_LOADING,
  T.POST_EMPLOYEE_SUCCESS,
  T.POST_EMPLOYEE_FAILURE,
  T.POST_EMPLOYEE_CLEAR,
);

export default combineReducers({
  putEmployee,
  putEmployeeCrmPermissions,
  postEmployee,
});
